<template>
  <div v-if="isAdmin || isCompanyAdmin">
    <h1>{{ company.tradingName }}</h1>
    <v-expansion-panels class="pr-12 mt-3">
      <v-expansion-panel>
        <v-expansion-panel-header
          ><h3>{{ company.tradingName }} details</h3></v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 v-if="isAdmin">
            Company type <span>{{ companyType }}</span>
          </h4>
          <h4>
            Executorship: <span>{{ executorship }}</span>
          </h4>
          <h4 v-if="company.nominatedExecutor">
            Nominated Executor: <span>{{ company.nominatedExecutor }}</span>
          </h4>
          <h4>
            Offer trust administration:
            <span>{{ offerTrustAdministration }}</span>
          </h4>
          <h4 v-if="company.offerTrustAdministration">
            Trust company name: <span>{{ company.trustCompanyName }}</span>
          </h4>
          <h4 v-if="company.offerTrustAdministration">
            Trust company registration number:
            <span>{{ company.trustCompanyRegNo }}</span>
          </h4>
          <h4>
            Offer wills for free? <span>{{ willPaymentOption }}</span>
          </h4>
          <h4>
            Executor's fee negotiable? <span>{{ executorFeeNegotiable }}</span>
          </h4>
          <h4>
            Default Executor fee:
            <span>{{ company.defaultExecutorFeePercentage }}%</span>
          </h4>
          <h4>
            Where should your agreed estate admin fee be displayed?
            <span>{{ executorFeeLocation }}</span>
          </h4>
          <h4 v-if="isAdmin">
            Insurance step: <span>{{ insuranceStep }}</span>
          </h4>
          <h4 v-if="isAdmin">
            Enable refer a friend? <span>{{ referAFriend }}</span>
          </h4>
          <h4 v-if="isAdmin">
            Enable reminder emails, sent to advisor after 30 days, if testator
            has not uploaded signed will?
            <span>{{ willUploadReminderEmail }}</span>
          </h4>
          <h4 v-if="isAdmin">
            Hide {{ whitelabel.name }} logo on will documents?
            <span>{{ hideQuickwillLogoOnWill }}</span>
          </h4>
          <h4 v-if="isAdmin">
            Enable contact center workflow?
            <span>{{ contactCenterWorkflow }}</span>
          </h4>
          <h4 v-if="isAdmin">
            Enable advisor appointment? <span>{{ contactCenterWorkflow }}</span>
          </h4>
          <h4 v-if="company.address">
            Address where will should be delivered for storage:
            <span>{{ company.address }}</span>
          </h4>
          <h4 v-if="company.logoUrl">
            Company logo:
            <span
              ><a
                :href="company.logoUrl"
                target="_blank"
                class="current-company-logo-link"
                >View current logo</a
              ></span
            >
          </h4>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  export default {
    name: 'CompanyDetails',
    props: {
      company: {
        required: true,
        type: Object,
      },
    },
    computed: {
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
      isCompanyAdmin() {
        return this.$store.getters.isCompanyAdmin;
      },
      executorFeeNegotiable() {
        return this.company.negotiableExecutorFee ? 'YES' : 'NO';
      },
      offerTrustAdministration() {
        return this.company.offerTrustAdministration ? 'YES' : 'NO';
      },
      referAFriend() {
        return this.company.referAFriend ? 'YES' : 'NO';
      },
      willUploadReminderEmail() {
        return this.company.willUploadReminderEmail ? 'YES' : 'NO';
      },
      hideQuickwillLogoOnWill() {
        return this.company.hideQuickwillLogoOnWill ? 'YES' : 'NO';
      },
      contactCenterWorkflow() {
        return this.company.contactCenterWorkflow ? 'YES' : 'NO';
      },
      advisorAppointment() {
        return this.company.advisorAppointment ? 'YES' : 'NO';
      },
      willPaymentOption() {
        switch (this.company.willPaymentOption) {
          case 'ALWAYS_FREE':
            return 'Always free';
          case 'FIRST_WILL_FREE':
            return 'First will free';
          case 'NOT_FREE':
            return 'Not free';
          default:
            return '';
        }
      },
      executorFeeLocation() {
        switch (this.company.executorFeeLocation) {
          case 'WILL':
            return 'In the will';
          case 'SIDE_AGREEMENT':
            return 'In a side agreement';
          default:
            return '';
        }
      },
      companyType() {
        switch (this.company.companyType) {
          case 'REFERRAL':
            return 'Referral company';
          case 'FINANCIAL_ADVISOR':
            return 'Financial advisor company';
          case 'AUTO_ASSIGN':
            return 'Auto assign company (new testators get auto assigned to consultants)';
          default:
            return '';
        }
      },
      insuranceStep() {
        switch (this.company.insuranceStep) {
          case 'NO_INSURANCE':
            return 'No insurance';
          case 'LIQUIDITY_CALCULATOR':
            return 'Liquidity calculator';
          case 'FULL_INSURANCE':
            return 'Full insurance';
          default:
            return '';
        }
      },
      executorship() {
        switch (this.company.executorship) {
          case 'COMPANY_ONLY':
            return 'Only our company';
          case 'COMPANY_OR_PERSON':
            return 'Our company or user selected nomination';
          case 'INTERNAL_COMPANY_OR_PERSON':
            return `${this.whitelabel.name} or user selected nomination`;
          case 'INTERNAL_COMPANY_ONLY':
            return `${this.whitelabel.name} only`;
          default:
            return '';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  h4 {
    margin: 4px 0 4px 10px;

    span {
      margin-left: 10px;
    }

    .current-company-logo-link {
      color: grey;
    }
  }
</style>
